import { c as _c } from "react/compiler-runtime";
import React, { type JSX } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { isYesterday } from 'shared/utils/date-time-format';
import { ArrowDownSmoothIcon } from '@systemeio/ui/icons';
export interface ChartBoxProps {
  title: string;
  total: string;
  diffPercents: number;
  countDays: number;
  dateSince: string | null;
  chart: JSX.Element;
}
const ChartBox = t0 => {
  const $ = _c(33);
  const {
    title,
    total,
    diffPercents,
    countDays,
    dateSince,
    chart
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    user
  } = useUser();
  let t1;
  if ($[0] !== title) {
    t1 = <span className="text-text-tertiary font-semibold leading-none">{title}</span>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== total) {
    t2 = <span className="text-brand-primary text-4xl leading-none">{total}</span>;
    $[2] = total;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="flex flex-col gap-2.5">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = `${diffPercents >= 0 ? "bg-old-green/[0.1] text-old-green" : "bg-old-red/[0.1] text-old-red"} flex h-fit flex-col rounded-md px-3.5 pb-2 pt-3`;
  const t5 = `${diffPercents >= 0 ? "fill-old-green" : "fill-old-red rotate-180"} scale-90`;
  let t6;
  if ($[7] !== t5) {
    t6 = <ArrowDownSmoothIcon className={t5} />;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== diffPercents) {
    t7 = <span className="text-[20px] font-bold leading-5">{diffPercents}%</span>;
    $[9] = diffPercents;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t6 || $[12] !== t7) {
    t8 = <div className="flex items-center gap-2">{t6}{t7}</div>;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== countDays || $[15] !== dateSince || $[16] !== t || $[17] !== user?.timezone) {
    t9 = isYesterday(dateSince, user?.timezone) && countDays === 1 ? t("dashboard.main.one_day_ago").toLowerCase() : t("dashboard.main.last_days", {
      count: countDays
    }).toLowerCase();
    $[14] = countDays;
    $[15] = dateSince;
    $[16] = t;
    $[17] = user?.timezone;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t9) {
    t10 = <span className="text-xs">{t9}</span>;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t4 || $[23] !== t8) {
    t11 = <div className={t4}>{t8}{t10}</div>;
    $[21] = t10;
    $[22] = t4;
    $[23] = t8;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t11 || $[26] !== t3) {
    t12 = <div className="flex justify-between px-6">{t3}{t11}</div>;
    $[25] = t11;
    $[26] = t3;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== chart) {
    t13 = <div className="ml-[0px] mr-[11px]">{chart}</div>;
    $[28] = chart;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t12 || $[31] !== t13) {
    t14 = <div className="shadow-old-design font-averta bg-background-secondary flex h-[340px] w-full flex-col justify-between rounded-lg pb-1 pt-6 md:w-[calc(50%-10px)] lg:w-full xl:w-[calc(50%-10px)]">{t12}{t13}</div>;
    $[30] = t12;
    $[31] = t13;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  return t14;
};
export default ChartBox;